import { useEffect, useState } from "react";
import Drawer from 'react-modern-drawer';
import Cue_listing from "./cue_listing";
import metaDataServices from "../MetaDataServices";
import Production_listing from "./production_listing";
import TableDatePicker from "components/PeriodSelection/DatePickerRange";

export default function CueProductUpsert(param: any) {

    var payLoad = { pageNumber: 1, pageSize: 10 };
    let [cueSelect, setcueSelect] = useState(false);
    let [isOpen, setIsOpen] = useState(param.cueOpen);
    let [productSelect, setProductSelect] = useState(false);
    let [cueUpsertData, SetcuelUpsertData] = useState<any>([]);
    let [cueProductlist, SetcueProductlist] = useState<any>([]);
    let [activeSubTab, setactiveSubTab] = useState("Production");
    let [showCueSuccessSaveMsg, setshowCueSuccessSaveMsg] = useState(false);

    const onCloseDrawer = () => {
        param.onChange();
        isOpen = false;
        setIsOpen(isOpen)
    }

    useEffect(() => {
        cueUpsertData = param.cueUpsert
        SetcuelUpsertData(cueUpsertData)

        if (param.cueUpsert && param.cueUpsert.cueProductId) {
            metaDataServices.cueProductgetById(param.cueUpsert.cueProductId)
        }
        cueProductList();
    }, [param.cueUpsert])

    const cueProductList = () => {
        metaDataServices.cueProductlistSearch(payLoad).then((res:any) => {
            cueProductlist = res
            SetcueProductlist(cueProductlist);
        })
    }

    const resetCueUpsertForm = () => {
        cueUpsertData = [];
        SetcuelUpsertData(cueUpsertData)
    }

    const saveCueUpsertForm = () => {

        if (cueUpsertData) {
            metaDataServices.cueProductSave(cueUpsertData).then((res:any) => {

                setshowCueSuccessSaveMsg(true)
                setTimeout(function () {
                    setshowCueSuccessSaveMsg(false);
                }, 3000);
            })
        }
    }

    const productSelection = (e: any) => {
        productSelect = false
        setProductSelect(productSelect)
    }

    const cueSelection = (e: any) => {
        console.log(e)
        cueSelect = false
        setcueSelect(cueSelect)

        if (e && e.masterCue) {
            SetcuelUpsertData({ ...cueUpsertData, masterCue: e.masterCue, })
        }
    }

    const selectProductCue = (e: any) => {
        console.log(e)
        param.onChange(e)
    }

    const dueDateChange = (e: any) => {
        console.log(e)

        const date = new Date(e);
        const isoString = date.toISOString();
        console.log(isoString)
        SetcuelUpsertData({ ...cueUpsertData, dueDate: isoString??"", })
    }

    const programAirChange = (e: any) => {
        console.log(e)

        const date = new Date(e);
        const isoString = date.toISOString();
        console.log(isoString)
        SetcuelUpsertData({ ...cueUpsertData, programAirDate: isoString??"", })
    }

    const masterFromDateChange = (e: any) => {
        console.log(e)
        const date = new Date(e);
        const isoString = date.toISOString();
        console.log(isoString)
        SetcuelUpsertData({ ...cueUpsertData, masterFromDate: isoString??"", })
    }

    const masterToDateChange = (e: any) => {
        console.log(e)
        const date = new Date(e);
        const isoString = date.toISOString();
        console.log(isoString)
        SetcuelUpsertData({ ...cueUpsertData, masterToDate: isoString??"", })
    }

    return (<>
        <Drawer open={isOpen}
            onClose={() => setIsOpen(false)}
            direction='right'
            className='react-drawer allowHscroll allowVscroll'
            size={800}>
            <div className="box noBorderRadius noBorder ws-7 pull-right landing">

                <div className="box-header  noBorderRadius bg-blue pLarge"> Add/Edit Cue Product</div>

                <div className="ws-12 pm">

                    <ul className=" ws-12 m0 pbl">
                        {<a onClick={() => { setactiveSubTab("Production"); }} className={activeSubTab === "Production" ? "btn-success active" : "btn-success"}>Production</a>}
                        {(param?.cueUpsert?.cueProductId) && <a onClick={() => { setactiveSubTab("Master Details"); }} className={activeSubTab === "Master Details" ? "btn-success active" : "btn-success"}>Master Details</a>}
                        {(param?.cueUpsert?.cueProductId) && <a onClick={() => { setactiveSubTab("Comments"); }} className={activeSubTab === "Comments" ? "btn-success active" : "btn-success"}>Comments</a>}
                    </ul>

                    {showCueSuccessSaveMsg && <div className="alert alert-success">Cue Product saved successfully  </div>}

                    {activeSubTab === "Production" && <div className="ws-12 ps box">

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Number</label>
                            <div className="label-entries">
                                <input className="ws-12" id="masterCue" name="masterCue" type="text" placeholder="Program Number" value={cueUpsertData?.programNumber ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programNumber: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Number</label>
                            <div className="label-entries">
                                <input className="w-80" id="masterCue" name="masterCue" type="text" placeholder="Production Number" value={cueUpsertData?.productionNumber ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productionNumber: e.target.value, })} />
                                <button className="icon-btn info height30 width90 pull-right" onClick={() => { setProductSelect(true) }}>Select</button>
                            </div>
                        </div>


                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Type</label>
                            <div className="label-entries">
                                <input className="ws-12" id="proramType" name="proramType" type="text" placeholder="Program Type" value={cueUpsertData?.proramType ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, proramType: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Name</label>
                            <div className="label-entries">
                                <input className="ws-12" id="productionName" name="productionName" type="text" placeholder="Production Name" value={cueUpsertData.productionName ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productionName: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Name</label>
                            <div className="label-entries">
                                <input className="ws-12" id="programName" name="programName" type="text" placeholder="Program Name" value={cueUpsertData?.programName ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programName: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Production Episode</label>
                            <div className="label-entries">
                                <input className="ws-12" id="productEpisode" name="productEpisode" type="text" placeholder="Production Episode" value={cueUpsertData?.productEpisode ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productEpisode: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Network Station</label>
                            <div className="label-entries">
                                <input className="ws-12" id="networkStation" name="networkStation" type="text" placeholder="Network Station" value={cueUpsertData?.networkStation ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, networkStation: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Season</label>
                            <div className="label-entries">
                                <input className="ws-12" id="productSeason" name="productSeason" type="text" placeholder="Program Season" value={cueUpsertData?.productSeason ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productSeason: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Due Date</label>
                            <div className="ws-12">
                                <TableDatePicker type={" "} data={cueUpsertData?.dueDate ?? ""} onChange={dueDateChange} />
                            </div>
                        </div>

                        <div className="ws-6 pm">
                            <label className="ws-12 text-bold">Program Air Date</label>
                            <div className="ws-12">
                                <TableDatePicker type={" "} data={cueUpsertData?.programAirDate ?? ""} onChange={programAirChange} />
                            </div>
                        </div>
                    </div>}

                    {activeSubTab === "Master Details" && <div className="ws-12 ps box">

                        <div className="ws-6">
                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Master From Date</label>
                                <div className="ws-12">
                                    <TableDatePicker type={" "} data={cueUpsertData?.masterFromDate ?? ""} onChange={masterFromDateChange} />
                                </div>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Master To Date</label>
                                <div className="ws-12">
                                    <TableDatePicker type={" "} data={cueUpsertData?.masterToDate ?? ""} onChange={masterToDateChange} />
                                </div>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Master Cue</label>
                                <input type="text" placeholder="Master Cue" className="w-83" name="masterCue" id="masterCue" value={cueUpsertData?.masterCue ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, masterCue: e.target.value, })} />
                                <button className="icon-btn icon-btn-save pbl text-center pull-right" onClick={() => { setcueSelect(true) }}> Cue</button>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Last Submitted Date</label>
                                <TableDatePicker type={" "} data={cueUpsertData?.lastSubmittedDate ?? ""} onChange={programAirChange} />
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Prepared By</label>
                                <input type="text" placeholder="Prepared By" className="ws-12 " name="preparedBy" id="preparedBy" value={cueUpsertData?.preparedBy ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, produpreparedByctPartNumber: e.target.value, })} />
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Part Number / EpN</label>
                                <input type="text" placeholder="Part Number" className="w-49 text-right" name="productPartNumber" value={cueUpsertData?.productPartNumber ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productPartNumber: e.target.value, })} />
                                <input type="text" placeholder="EpN" className="w-49 text-right pull-right" name="productEpN" value={cueUpsertData?.productEpN ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productEpN: e.target.value, })} />
                            </div>
                        </div>

                        <div className="ws-6">
                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Duration</label>
                                <input type="text" placeholder="Minutes" className="w-49 text-right" name="programDurationMinute" value={cueUpsertData?.programDurationMinute} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programDurationMinute: e.target.value, })} />
                                <input type="text" placeholder="Seconds" className="w-49 text-right pull-right" name="programDurationSecond" value={cueUpsertData?.programDurationSecond} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programDurationSecond: e.target.value, })} />
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Year / Year Ext</label>
                                <input type="text" placeholder="Year" className="w-49 text-right" name="productionYear" value={cueUpsertData?.productionYear} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productionYear: e.target.value, })} />
                                <input type="text" placeholder="Year Ext" className="pull-right w-49 text-right" name="productionYearExt" value={cueUpsertData?.productionYearExt} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, productionYearExt: e.target.value, })} />
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Runtime</label>
                                <input type="text" placeholder="Minutes" className="w-49 text-right" name="runtimeDurationMinute" value={cueUpsertData?.runtimeDurationMinute} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, runtimeDurationMinute: e.target.value, })} />
                                <input type="text" placeholder="Seconds" className="pull-right w-49 text-right" name="runtimeDurationSecond" value={cueUpsertData?.runtimeDurationSecond} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, runtimeDurationSecond: e.target.value, })} />
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Animated Indicator</label>
                                <label className="inline ws-4">Y <input type="radio" name="animatedIndicator" value="true" checked={cueUpsertData?.animatedIndicator == true} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, animatedIndicator: e.target.value, })} /></label>
                                <label className="inline ws-4">N <input type="radio" name="animatedIndicator" value="false" checked={cueUpsertData?.animatedIndicator == false} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, animatedIndicator: e.target.value, })} /></label>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Template Indicator</label>
                                <label className="inline ws-4">Y <input type="radio" name="templateIndicator" value="true" checked={cueUpsertData?.templateIndicator == true} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, templateIndicator: e.target.value, })} /></label>
                                <label className="inline ws-4">N <input type="radio" name="templateIndicator" value="false" checked={cueUpsertData?.templateIndicator == false} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, templateIndicator: e.target.value, })} /></label>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Music Content</label>
                                <label className="inline ws-4">Y <input type="radio" name="musicContentIndicator" value="true" checked={cueUpsertData?.musicContentIndicator == true} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, musicContentIndicator: e.target.value, })} /></label>
                                <label className="inline ws-4">N <input type="radio" name="musicContentIndicator" value="false" checked={cueUpsertData?.musicContentIndicator == false} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, musicContentIndicator: e.target.value, })} /></label>
                            </div>

                            <div className="ws-12 pm">
                                <label className="ws-12 text-bold">Syndicated</label>
                                <label className="inline ws-4">Y <input type="radio" name="syndicated" value="true" checked={cueUpsertData?.syndicated == true} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, syndicated: e.target.value, })} /></label>
                                <label className="inline ws-4">N <input type="radio" name="syndicated" value="false" checked={cueUpsertData?.syndicated == false} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, syndicated: e.target.value, })} /></label>
                            </div>
                        </div>

                    </div>}

                    {activeSubTab === "Comments" && <div className="ws-12 ps box">
                        <div className="row-fluid">
                            <div className="ws-12">
                                <div className="ws-12">
                                    <div className="form-format">
                                        <label className="control-label">Program Comments</label>
                                        <textarea id="programComments" name="programComments" placeholder="Program Comments" style={{ height: "50px", width: "550px" }} value={cueUpsertData?.programComments ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programNumber: e.target.value, })}></textarea>
                                    </div>

                                    <div className="form-format">
                                        <label className="control-label">Program Instructions</label>
                                        <textarea id="programInstructions" name="programInstructions" placeholder="Program Instructions" style={{ height: "50px", width: "550px" }} value={cueUpsertData?.programInstructions ?? ""} onChange={(e: any) => SetcuelUpsertData({ ...cueUpsertData, programNumber: e.target.value, })}></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>}

                </div>

                <div className="ws-12 pm ">
                    {(!(param?.cueUpsert?.cueProductId) || activeSubTab === "Master Details" || activeSubTab === "Comments") && <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>}
                    <button type="button" className="icon-btn delete pull-right" onClick={() => resetCueUpsertForm()}>↻ Reset</button>
                    <button type="button" className="icon-btn edit pull-right" onClick={() => saveCueUpsertForm()}>✔ Save</button>
                </div>

                {((param?.cueUpsert?.cueProductId) && activeSubTab !== "Master Details" && activeSubTab != "Comments") && <div className="ws-12 pm ">
                    <div className="box ws-12 pm allowHscroll allowVscroll">
                        <table className="newTable mtl">
                            <thead>
                                <tr>
                                    <th className="forceSingleLine">Program Type</th>
                                    <th className="forceSingleLine">Program Name</th>
                                    <th className="forceSingleLine">Program Number</th>
                                    <th className="forceSingleLine">Production Number</th>
                                    <th className="forceSingleLine">Production Name</th>
                                    <th className="forceSingleLine">Master Cue</th>
                                    <th className="forceSingleLine">Runtime Duration</th>
                                    <th>Operation</th>
                                </tr>
                            </thead>
                            <tbody>

                                {cueProductlist?.map((values: any) => {
                                    return (<tr>
                                        <td>{values.proramType}</td>
                                        <td className="forceSingleLine">{values.programName}</td>
                                        <td>{values.programNumber}</td>
                                        <td>{values.productionNumber}</td>
                                        <td>{values.productionName}</td>
                                        <td>{values.masterCue}</td>
                                        <td>{String(values.runtimeDurationMinute).padStart(2, '0')} : {String(values.runtimeDurationSecond).padStart(2, '0')} </td>
                                        <td>  <button className="icon-btn info " onClick={() => selectProductCue(values)}> Select </button></td>
                                    </tr>)
                                })}

                            </tbody>

                        </table>

                    </div>
                </div>}

                {(param?.cueUpsert?.cueProductId && activeSubTab !== "Master Details" && activeSubTab != "Comments") && <div className="ws-12 pm ">
                    <button type="button" className="icon-btn delete pull-right" onClick={() => onCloseDrawer()}>x Close</button>
                </div>}
            </div>

            {
                (() => {
                    if (productSelect) {
                        return <Production_listing onChange={productSelection} productSelect={productSelect} />
                    }
                    if (cueSelect) {
                        return <Cue_listing onChange={cueSelection} productSelect={cueSelect} />
                    }

                })()
            }

        </Drawer>
    </>)
}